import React from 'react';

// chakra imports
import {
  Box, Drawer,
  DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay, Flex, Icon,
  useColorModeValue, useDisclosure
} from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { renderThumb, renderTrack, renderView } from 'shared/components/horizon-ui/scrollbar/Scrollbar';
import Content from 'shared/components/horizon-ui/sidebar/components/Content';

// Assets
import { IoMenuOutline } from 'react-icons/io5';
import { GroupT } from 'shared/routes';
import { SIDEBAR_WIDTH } from "shared/utils/constants";

function Sidebar(props: { groups: GroupT[];[x: string]: FixMeLater }) {
  const { groups } = props;


  const variantChange = '0.2s linear';
  const sidebarBg = useColorModeValue('white', 'navy.800');
  const sidebarMargins = '0px';

  // SIDEBAR
  return (
    <Box display={{ sm: 'none', xl: 'block' }} position='fixed' minH='100%'>
      <Box
        bg="transparent"
        transition={variantChange}
        w='280px'
        h='100vh'
        m={sidebarMargins}
        minH='100%'
        overflowX='hidden'
        backgroundColor={sidebarBg}
        pb="20px"
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
          style={{ height: 'max-content' }}
        >
          <Content groups={groups} />
        </Scrollbars>
      </Box>
    </Box>
  );
}

// FUNCTIONS
export function SidebarResponsive(props: { groups: GroupT[] }) {
  const menuColor = useColorModeValue('gray.400', 'white');
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { groups } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ sm: 'flex', xl: 'none' }} alignItems='center'>
      <Flex ref={btnRef} w='max-content' h='max-content' onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my='auto'
          w='20px'
          h='20px'
          me='10px'
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent w={`${SIDEBAR_WIDTH}px`} maxW={`${SIDEBAR_WIDTH}px`} bg="white">
          <DrawerCloseButton
            zIndex='3'
            onClick={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody maxW='285px' px='0rem' pb='0' height="max-content">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
              style={{ height: 'max-content', overflow: 'none' }}
            >
              <Content groups={groups} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

export default Sidebar;
